/**
 * Search Box widget.
 */
class SearchBox {
	widget;
	form;
	toggle;
	mediaQuery;

	/**
	 * Instantiate class for each widget.
	 * 
	 * @param {HTMLElement} widget
	 */
	constructor( widget ) {
		this.widget = widget;
		this.form = widget.querySelector( '.search-form' );
		this.toggle = widget.querySelector( '.search-toggle' );
		this.mediaQuery = window.matchMedia( '(max-width: 768px)' );

		if( !this.form || !this.toggle ) {
			return;
		}

		/**
		 * Set viewport events
		 */
		this.setViewport(); // Set viewport on load
		this.mediaQuery.addEventListener( 'change', () => this.setViewport() ); // On media query change

		/**
		 * Main menu toggle
		 */
		this.toggle.addEventListener( 'click', () => this.toggleForm() );
	}

	/**
	 * Set menu element properties for each viewport.
	 */
	setViewport() {
		if( this.mediaQuery.matches ) { // Mobile
			this.form.hidden = true;
			this.form.setAttribute( 'aria-expanded', 'false' );
		} else { // Desktop
			this.form.hidden = false;
			this.form.removeAttribute( 'aria-expanded' );
			this.widget.classList.remove( 'active' );
			document.body.classList.remove( 'whippet-search-box--active' );
		}
	}

	/**
	 * Toggle main menu open or close state.
	 */
	toggleForm() {
		this.form.hidden = !this.form.hidden;
		this.form.setAttribute( 'aria-expanded', this.form.hidden ? 'false' : 'true' );
		this.widget.classList.toggle( 'active' );
		
		if( !this.form.hidden ) {
			this.form.querySelector( 'input' ).focus();
			document.body.classList.add( 'whippet-search-box--active' );
		} else {
			document.body.classList.remove( 'whippet-search-box--active' );
		}
	}
}

document.querySelectorAll( '.whippet-search-box--responsive' ).forEach( widget => {
	new SearchBox( widget );
} );
